import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(auth)/login/page.jsx")